import * as pdfMake from 'pdfmake/build/pdfmake';
import dayjs from 'dayjs';
import vfsFonts from "pdfmake/build/vfs_fonts";   // ไฟล์ที่ generate ไว้เอง


// ตั้งค่าให้ pdfMake ใช้ฟอนต์จาก vfs_fonts
pdfMake.vfs = vfsFonts;
//pdfMake.addVirtualFileSystem(vfsFonts);


pdfMake.fonts = {
    THSarabunNew: {
        normal: 'THSarabunNew.ttf',
        bold: 'THSarabunNew Bold.ttf',
        italics: 'THSarabunNew Italic.ttf',
        bolditalics: 'THSarabunNew BoldItalic.ttf'
    }
};


// ฟังก์ชันจัดรูปแบบตัวเลขสำหรับ PDF
const formatCurrency = (value) => {
  if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
    return '฿0';
  }
  const numValue = parseFloat(value);
  if (isNaN(numValue)) {
    return '฿0';
  }
  return `฿${numValue.toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
};

const formatNumber = (value, suffix = '') => {
  if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
    return `0${suffix ? ' ' + suffix : ''}`;
  }
  const numValue = parseFloat(value);
  if (isNaN(numValue)) {
    return `0${suffix ? ' ' + suffix : ''}`;
  }
  return `${numValue.toLocaleString('th-TH')}${suffix ? ' ' + suffix : ''}`;
};

// สไตล์พื้นฐานสำหรับ PDF
const getStyles = () => ({
  header: {
    fontSize: 18,
    bold: true,
    alignment: 'center',
    margin: [0, 0, 0, 20],
    font: 'THSarabunNew'
  },
  subheader: {
    fontSize: 18,
    bold: true,
    margin: [0, 10, 0, 5],
    font: 'THSarabunNew'
  },
  tableHeader: {
    bold: true,
    fontSize: 18,
    color: 'black',
    fillColor: '#eeeeee',
    font: 'THSarabunNew'
  },
  tableCell: {
    fontSize: 18,
    margin: [0, 2, 0, 2],
    font: 'THSarabunNew'
  },
  summary: {
    fontSize: 18,
    bold: true,
    margin: [0, 5, 0, 5],
    font: 'THSarabunNew'
  },
  footer: {
    fontSize: 18,
    italics: true,
    alignment: 'center',
    margin: [0, 10, 0, 0],
    font: 'THSarabunNew'
  },
  normal: {
    font: 'THSarabunNew',
    fontSize: 18
  }
});

// ฟังก์ชันสร้าง header ของ PDF
const createPDFHeader = (reportTitle, sectionTitle = null, dateRange = null) => {
  const header = [
    { text: reportTitle, style: 'header' }
  ];

  if (sectionTitle) {
    header.push({
      text: sectionTitle,
      style: 'subheader',
      alignment: 'center'
    });
  }

  if (dateRange && dateRange.length === 2) {
    header.push({
      text: `ช่วงวันที่: ${dayjs(dateRange[0]).format('DD/MM/YYYY')} - ${dayjs(dateRange[1]).format('DD/MM/YYYY')}`,
      style: 'subheader',
      alignment: 'center'
    });
  }

  header.push({
    text: `วันที่พิมพ์: ${dayjs().format('DD/MM/YYYY HH:mm')}`,
    fontSize: 10,
    alignment: 'right',
    margin: [0, 0, 0, 20],
    font: 'THSarabunNew'
  });

  return header;
};

// ฟังก์ชันสร้างตาราง
const createTable = (headers, data, columnWidths = null) => {
  const tableBody = [headers];
  data.forEach(row => {
    tableBody.push(row);
  });

  const table = {
    table: {
      headerRows: 1,
      body: tableBody,
      widths: columnWidths || headers.map(() => '*')
    },
    layout: {
      fillColor: function (rowIndex, node, columnIndex) {
        return (rowIndex === 0) ? '#eeeeee' : null;
      }
    },
    style: 'tableCell'
  };

  return table;
};

// ===== DASHBOARD SECTIONS =====

// 1. Dashboard - ภาพรวม
const generateDashboardOverviewPDF = (data) => {
  const { summary = {} } = data;

  const content = [
    ...createPDFHeader('รายงานแดชบอร์ด', 'ภาพรวม'),
    
    { text: 'สรุปผลการดำเนินงาน', style: 'subheader' },
    
    createTable(
      [
        { text: 'รายการ', style: 'tableHeader' },
        { text: 'จำนวน', style: 'tableHeader' }
      ],
      [
        ['ยอดขายเดือนนี้', formatCurrency(summary.total_sales)],
        ['ค่าใช้จ่ายเดือนนี้', formatCurrency(summary.total_expenses)],
        ['กำไรสุทธิ', formatCurrency(summary.net_profit)],
        ['สินค้าใกล้หมด', formatNumber(summary.low_stock_items, 'รายการ')],
        ['ลูกหนี้คงค้าง', formatCurrency(summary.outstanding_amount)],
        ['รายการขายเดือนนี้', formatNumber(summary.paid_receipts, 'รายการ')]
      ],
      ['*', '*']
    )
  ];

  return content;
};

// 2. Dashboard - กิจกรรมล่าสุด
const generateDashboardActivitiesPDF = (data) => {
  const { recent_activities = {} } = data;

  const content = [
    ...createPDFHeader('รายงานแดชบอร์ด', 'กิจกรรมล่าสุด'),
    
    { text: 'ใบเสร็จล่าสุด', style: 'subheader' },
    
    createTable(
      [
        { text: 'เลขที่ใบเสร็จ', style: 'tableHeader' },
        { text: 'วันที่', style: 'tableHeader' },
        { text: 'ลูกค้า', style: 'tableHeader' },
        { text: 'จำนวนเงิน', style: 'tableHeader' }
      ],
      (recent_activities.receipts || []).slice(0, 15).map(receipt => [
        receipt.invoice_number || receipt.receipt_number || '-',
        dayjs(receipt.receipt_date).format('DD/MM/YYYY'),
        receipt.customer_name || '-',
        formatCurrency(receipt.total_amount)
      ]),
      ['*', 100, '*', 100]
    ),

    { text: '', margin: [0, 20, 0, 10] },
    { text: 'ค่าใช้จ่ายล่าสุด', style: 'subheader' },
    
    createTable(
      [
        { text: 'เลขที่', style: 'tableHeader' },
        { text: 'วันที่', style: 'tableHeader' },
        { text: 'รายการ', style: 'tableHeader' },
        { text: 'จำนวนเงิน', style: 'tableHeader' }
      ],
      (recent_activities.expenses || []).slice(0, 15).map(expense => [
        expense.expense_number || '-',
        dayjs(expense.expense_date).format('DD/MM/YYYY'),
        expense.description || '-',
        formatCurrency(expense.total_amount)
      ]),
      ['*', 100, '*', 100]
    )
  ];

  return content;
};

// 3. Dashboard - กำหนดการที่จะมาถึง
const generateDashboardEventsPDF = (data) => {
  const { upcoming_events = [] } = data;

  const content = [
    ...createPDFHeader('รายงานแดชบอร์ด', 'กำหนดการที่จะมาถึง'),
    
    { text: 'รายการกิจกรรมที่จะมาถึง', style: 'subheader' },
    
    createTable(
      [
        { text: 'ชื่อกิจกรรม', style: 'tableHeader' },
        { text: 'วันที่', style: 'tableHeader' },
        { text: 'เวลา', style: 'tableHeader' }
      ],
      upcoming_events.map(event => [
        event.title || '-',
        dayjs(event.start_date).format('DD/MM/YYYY'),
        event.start_time || '-'
      ]),
      ['*', 120, 100]
    )
  ];

  return content;
};

// ===== INVENTORY SECTIONS =====

// 4. Inventory - สรุปภาพรวม
const generateInventorySummaryPDF = (data) => {
  const { summary = {}, categoryBreakdown = [] } = data;

  const content = [
    ...createPDFHeader('รายงานต้นทุนสินค้าคงเหลือ', 'สรุปภาพรวม'),
    
    { text: 'สรุปข้อมูลสินค้าคงเหลือ', style: 'subheader' },
    
    createTable(
      [
        { text: 'รายการ', style: 'tableHeader' },
        { text: 'จำนวน', style: 'tableHeader' }
      ],
      [
        ['จำนวนสินค้าทั้งหมด', formatNumber(summary.total_products, 'รายการ')],
        ['จำนวนคงเหลือรวม', formatNumber( parseFloat(summary.total_stock), 'ชิ้น')],
        ['มูลค่ารวมต้นทุน', formatCurrency(summary.total_cost_value)],
        ['มูลค่ารวมขาย', formatCurrency(summary.total_sell_value)],
        ['กำไรสะสม', formatCurrency(summary.potential_profit)],
        ['สินค้าใกล้หมด', formatNumber(summary.low_stock_items, 'รายการ')]
      ],
      ['*', '*']
    ),

    { text: '', margin: [0, 20, 0, 10] },
    { text: 'แยกตามหมวดหมู่', style: 'subheader' },
    
    createTable(
      [
        { text: 'หมวดหมู่', style: 'tableHeader' },
        { text: 'จำนวนสินค้า', style: 'tableHeader' },
        { text: 'มูลค่ารวม', style: 'tableHeader' }
      ],
      categoryBreakdown.map(category => [
        category.category || 'ไม่ระบุ',
        formatNumber(category.products, 'รายการ'),
        formatCurrency(category.total_cost_value)
      ]),
      ['*', 120, 120]
    )
  ];

  return content;
};

// 5. Inventory - รายละเอียดสินค้า
const generateInventoryDetailsPDF = (data) => {
  const { products = [] } = data;

  const content = [
    ...createPDFHeader('รายงานต้นทุนสินค้าคงเหลือ', 'รายละเอียดสินค้า'),
    
    { text: 'รายละเอียดสินค้าคงเหลือ', style: 'subheader' },
    
    createTable(
      [
        { text: 'รหัส', style: 'tableHeader' },
        { text: 'ชื่อสินค้า', style: 'tableHeader' },
        { text: 'หมวดหมู่', style: 'tableHeader' },
        { text: 'คงเหลือ', style: 'tableHeader' },
        { text: 'ต้นทุน/หน่วย', style: 'tableHeader' },
        { text: 'มูลค่ารวม', style: 'tableHeader' }
      ],
      products.slice(0, 50).map(product => [
        product.id || '-',
        product.name || '-',
        product.category || 'ไม่ระบุ',
        formatNumber(product.stock) + (product.unit ? ` ${product.unit}` : ''),
        formatCurrency(product.cost),
        formatCurrency(product.total_cost_value)
      ]),
      [60, '*', 60, 60, 60, 60]
    )
  ];

  return content;
};

// ===== SALES SECTIONS =====

// 6. Sales - รายวัน
const generateSalesDailyPDF = (data, dateRange) => {
  const { summary = {}, salesOverTime = [] } = data;
  
  const dailyData = salesOverTime.filter(item => 
    item.period && item.period.includes('-') && item.period.split('-').length === 3
  );

  const content = [
    ...createPDFHeader('รายงานยอดขาย', 'รายงานรายวัน', dateRange),
    
    { text: 'สรุปยอดขายรายวัน', style: 'subheader' },
    
    createTable(
      [
        { text: 'วันที่', style: 'tableHeader' },
        { text: 'จำนวนใบเสร็จ', style: 'tableHeader' },
        { text: 'ยอดขาย', style: 'tableHeader' },
        { text: 'ยอดขายเฉลี่ย', style: 'tableHeader' }
      ],
      dailyData.map(item => [
        item.label || item.period || '-',
        formatNumber(item.total_receipts, 'รายการ'),
        formatCurrency(item.total_sales),
        formatCurrency(item.average_sale)
      ]),
      [100, 100, 100, 100]
    )
  ];

  return content;
};

// 7. Sales - รายเดือน
const generateSalesMonthlyPDF = (data, dateRange) => {
  const { summary = {}, salesOverTime = [] } = data;
  
  const monthlyData = salesOverTime.filter(item => 
    item.period && (item.period.includes('เดือน') || (item.period.includes('-') && item.period.split('-').length === 2))
  );

  const content = [
    ...createPDFHeader('รายงานยอดขาย', 'รายงานรายเดือน', dateRange),
    
    { text: 'สรุปยอดขายรายเดือน', style: 'subheader' },
    
    createTable(
      [
        { text: 'เดือน', style: 'tableHeader' },
        { text: 'จำนวนใบเสร็จ', style: 'tableHeader' },
        { text: 'ยอดขาย', style: 'tableHeader' },
        { text: 'ยอดขายเฉลี่ย', style: 'tableHeader' }
      ],
      monthlyData.map(item => [
        item.label || item.period || '-',
        formatNumber(item.total_receipts, 'รายการ'),
        formatCurrency(item.total_sales),
        formatCurrency(item.average_sale)
      ]),
      [100, 100, 100, 100]
    )
  ];

  return content;
};

// 8. Sales - รายปี
const generateSalesYearlyPDF = (data, dateRange) => {
  const { summary = {}, salesOverTime = [] } = data;
  
  const yearlyData = salesOverTime.filter(item => 
    item.period && (item.period.includes('year') || item.period.length === 4)
  );

  const content = [
    ...createPDFHeader('รายงานยอดขาย', 'รายงานรายปี', dateRange),
    
    { text: 'สรุปยอดขายรายปี', style: 'subheader' },
    
    createTable(
      [
        { text: 'ปี', style: 'tableHeader' },
        { text: 'จำนวนใบเสร็จ', style: 'tableHeader' },
        { text: 'ยอดขาย', style: 'tableHeader' },
        { text: 'ยอดขายเฉลี่ย', style: 'tableHeader' }
      ],
      yearlyData.map(item => [
        item.label || item.period || '-',
        formatNumber(item.total_receipts, 'รายการ'),
        formatCurrency(item.total_sales),
        formatCurrency(item.average_sale)
      ]),
      [100, 100, 100, 100]
    )
  ];

  return content;
};

// ===== EXPENSES SECTIONS =====

// 9. Expenses - สรุปค่าใช้จ่าย
const generateExpensesSummaryPDF = (data, dateRange) => {
  const { summary = {} } = data;

  const content = [
    ...createPDFHeader('รายงานค่าใช้จ่าย', 'สรุปค่าใช้จ่าย', dateRange),
    
    { text: 'สรุปข้อมูลค่าใช้จ่าย', style: 'subheader' },
    
    createTable(
      [
        { text: 'รายการ', style: 'tableHeader' },
        { text: 'จำนวน', style: 'tableHeader' }
      ],
      [
        ['จำนวนรายการทั้งหมด', formatNumber(summary.total_expenses, 'รายการ')],
        ['ยอดรวมค่าใช้จ่าย', formatCurrency(summary.total_amount)],
        ['ค่าใช้จ่ายเฉลี่ย', formatCurrency(summary.average_expense)],
        ['ค่าใช้จ่ายสูงสุด', formatCurrency(summary.max_expense)],
        ['ค่าใช้จ่ายต่ำสุด', formatCurrency(summary.min_expense)]
      ],
      ['*', '*']
    )
  ];

  return content;
};

// 10. Expenses - ตามช่วงเวลา
const generateExpensesTimePDF = (data, dateRange) => {
  const { expensesOverTime = [] } = data;

  const content = [
    ...createPDFHeader('รายงานค่าใช้จ่าย', 'ตามช่วงเวลา', dateRange),
    
    { text: 'ค่าใช้จ่ายตามช่วงเวลา', style: 'subheader' },
    
    createTable(
      [
        { text: 'ช่วงเวลา', style: 'tableHeader' },
        { text: 'จำนวนรายการ', style: 'tableHeader' },
        { text: 'ยอดรวม', style: 'tableHeader' }
      ],
      expensesOverTime.map(item => [
        item.period || '-',
        formatNumber(item.total_expenses, 'รายการ'),
        formatCurrency(item.total_amount)
      ]),
      ['*', 120, 120]
    )
  ];

  return content;
};

// 11. Expenses - ตามหมวดหมู่
const generateExpensesCategoryPDF = (data, dateRange) => {
  const { expensesByCategory = [] } = data;

  const content = [
    ...createPDFHeader('รายงานค่าใช้จ่าย', 'ตามหมวดหมู่', dateRange),
    
    { text: 'ค่าใช้จ่ายตามหมวดหมู่', style: 'subheader' },
    
    createTable(
      [
        { text: 'หมวดหมู่', style: 'tableHeader' },
        { text: 'จำนวนรายการ', style: 'tableHeader' },
        { text: 'ยอดรวม', style: 'tableHeader' },
        { text: 'ค่าเฉลี่ย', style: 'tableHeader' }
      ],
      expensesByCategory.map(category => [
        category.category || 'ไม่ระบุ',
        formatNumber(category.total_expenses, 'รายการ'),
        formatCurrency(category.total_amount),
        formatCurrency(category.average_expense)
      ]),
      ['*', 100, 100, 100]
    )
  ];

  return content;
};

// 12. Expenses - ตามผู้จำหน่าย
const generateExpensesSupplierPDF = (data, dateRange) => {
  const { expensesBySupplier = [] } = data;

  const content = [
    ...createPDFHeader('รายงานค่าใช้จ่าย', 'ตามผู้จำหน่าย', dateRange),
    
    { text: 'ค่าใช้จ่ายตามผู้จำหน่าย', style: 'subheader' },
    
    createTable(
      [
        { text: 'ผู้จำหน่าย', style: 'tableHeader' },
        { text: 'จำนวนรายการ', style: 'tableHeader' },
        { text: 'ยอดรวม', style: 'tableHeader' }
      ],
      expensesBySupplier.map(supplier => [
        supplier.supplier_name || 'ไม่ระบุ',
        formatNumber(supplier.total_expenses, 'รายการ'),
        formatCurrency(supplier.total_amount)
      ]),
      ['*', 100, 100, 100]
    )
  ];

  return content;
};

// ===== FINANCIAL SECTIONS =====

// 13. Financial - สรุปทางการเงิน
const generateFinancialSummaryPDF = (data, dateRange) => {
  const { summary = {}, balanceSheet = {} } = data;

  const content = [
    ...createPDFHeader('รายงานงบการเงิน', 'สรุปทางการเงิน', dateRange),
    
    { text: 'สรุปสถานะการเงิน', style: 'subheader' },
    
    createTable(
      [
        { text: 'รายการ', style: 'tableHeader' },
        { text: 'จำนวน', style: 'tableHeader' }
      ],
      [
        ['ยอดขายรวม', formatCurrency(summary.total_revenue)],
        ['ต้นทุนขาย', formatCurrency(summary.cost_of_goods_sold)],
        ['กำไรขั้นต้น', formatCurrency(summary.gross_profit)],
        ['ค่าใช้จ่ายดำเนินงาน', formatCurrency(summary.total_expenses)],
        ['กำไรสุทธิ', formatCurrency(summary.net_profit)],
        ['เงินสดคงเหลือ', formatCurrency(balanceSheet.cash_balance)],
        // ['ลูกหนี้', formatCurrency(balanceSheet.accounts_receivable)],
        // ['เจ้าหนี้', formatCurrency(balanceSheet.accounts_payable)]
      ],
      ['*', '*']
    )
  ];

  return content;
};

// 14. Financial - กระแสเงินสด
const generateFinancialCashflowPDF = (data, dateRange) => {
  const { cashFlowData = [] } = data;

  const content = [
    ...createPDFHeader('รายงานงบการเงิน', 'กระแสเงินสด', dateRange),
    
    { text: 'รายงานกระแสเงินสด', style: 'subheader' },
    
    createTable(
      [
        { text: 'วันที่', style: 'tableHeader' },
        { text: 'เงินเข้า', style: 'tableHeader' },
        { text: 'เงินออก', style: 'tableHeader' },
        { text: 'ยอดคงเหลือ', style: 'tableHeader' }
      ],
      cashFlowData.slice(0, 30).map(item => [
        dayjs(item.date).format('DD/MM/YYYY'),
        formatCurrency(item.revenue || 0),
        formatCurrency(item.expenses || 0),
        formatCurrency(item.net_cash_flow)
      ]),
      [80, '*', 80, 80, 80]
    )
  ];

  return content;
};

// ===== PROFIT-LOSS SECTIONS =====

// 15. Profit-Loss - รายวัน
const generateProfitLossDailyPDF = (data, dateRange) => {
  const dailyData = data.filter(item => 
    item.period && item.period.includes('-') && item.period.split('-').length === 3
  );

  const content = [
    ...createPDFHeader('รายงานกำไร/ขาดทุน', 'รายงานรายวัน', dateRange),
    
    { text: 'กำไร/ขาดทุนรายวัน', style: 'subheader' },
    
    createTable(
      [
        { text: 'วันที่', style: 'tableHeader' },
        { text: 'รายได้', style: 'tableHeader' },
        { text: 'ค่าใช้จ่าย', style: 'tableHeader' },
        { text: 'กำไร/ขาดทุน', style: 'tableHeader' }
      ],
      dailyData.map(item => [
        item.period || '-',
        formatCurrency(item.revenue),
        formatCurrency(item.total_expenses),
        formatCurrency(item.net_profit)
      ]),
      [100, 100, 100, 100]
    )
  ];

  return content;
};

// 16. Profit-Loss - รายสัปดาห์
const generateProfitLossWeeklyPDF = (data, dateRange) => {
  const weeklyData = data.filter(item => 
    item.period && (item.period.includes('-'))
  );

  const content = [
    ...createPDFHeader('รายงานกำไร/ขาดทุน', 'รายงานรายสัปดาห์', dateRange),
    
    { text: 'กำไร/ขาดทุนรายสัปดาห์', style: 'subheader' },
    
    createTable(
      [
        { text: 'สัปดาห์', style: 'tableHeader' },
        { text: 'รายได้', style: 'tableHeader' },
        { text: 'ค่าใช้จ่าย', style: 'tableHeader' },
        { text: 'กำไร/ขาดทุน', style: 'tableHeader' }
      ],
      weeklyData.map(item => [
        item.period || '-',
        formatCurrency(item.revenue),
        formatCurrency(item.total_expenses),
        formatCurrency(item.net_profit)
      ]),
      [100, 100, 100, 100]
    )
  ];

  return content;
};

// 17. Profit-Loss - รายเดือน
const generateProfitLossMonthlyPDF = (data, dateRange) => {
  const monthlyData = data.filter(item => 
    item.period && (item.period.includes('month') || (item.period.includes('-') && item.period.split('-').length === 2))
  );

  const content = [
    ...createPDFHeader('รายงานกำไร/ขาดทุน', 'รายงานรายเดือน', dateRange),
    
    { text: 'กำไร/ขาดทุนรายเดือน', style: 'subheader' },
    
    createTable(
      [
        { text: 'เดือน', style: 'tableHeader' },
        { text: 'รายได้', style: 'tableHeader' },
        { text: 'ค่าใช้จ่าย', style: 'tableHeader' },
        { text: 'กำไร/ขาดทุน', style: 'tableHeader' }
      ],
      monthlyData.map(item => [
        item.period || '-',
        formatCurrency(item.revenue),
        formatCurrency(item.total_expenses),
        formatCurrency(item.net_profit)
      ]),
      [100, 100, 100, 100]
    )
  ];

  return content;
};

// 18. Profit-Loss - รายปี
const generateProfitLossYearlyPDF = (data, dateRange) => {
  const yearlyData = data.filter(item => 
    item.period && (item.period.includes('ปี') || item.period.length === 4)
  );

  const content = [
    ...createPDFHeader('รายงานกำไร/ขาดทุน', 'รายงานรายปี', dateRange),
    
    { text: 'กำไร/ขาดทุนรายปี', style: 'subheader' },
    
    createTable(
      [
        { text: 'ปี', style: 'tableHeader' },
        { text: 'รายได้', style: 'tableHeader' },
        { text: 'ค่าใช้จ่าย', style: 'tableHeader' },
        { text: 'กำไร/ขาดทุน', style: 'tableHeader' }
      ],
      yearlyData.map(item => [
        item.period || '-',
        formatCurrency(item.revenue),
        formatCurrency(item.total_expenses),
        formatCurrency(item.net_profit)
      ]),
      [100, 100, 100, 100]
    )
  ];

  return content;
};

// ===== MAIN FUNCTIONS =====

// ฟังก์ชันสร้าง PDF แยกตาม section
const generateSectionPDF = async (reportType, section, reportData, reportTitle, dateRange = null) => {
  let content = [];

  try {
    switch (reportType) {
      case 'dashboard':
        switch (section) {
          case 'overview':
            content = generateDashboardOverviewPDF(reportData);
            break;
          case 'activities':
            content = generateDashboardActivitiesPDF(reportData);
            break;
          case 'events':
            content = generateDashboardEventsPDF(reportData);
            break;
          default:
            throw new Error('ไม่พบส่วนที่ระบุในรายงานแดชบอร์ด');
        }
        break;

      case 'inventory':
        switch (section) {
          case 'summary':
            content = generateInventorySummaryPDF(reportData);
            break;
          case 'products':
            content = generateInventoryDetailsPDF(reportData);
            break;
          default:
            throw new Error('ไม่พบส่วนที่ระบุในรายงานสินค้าคงเหลือ');
        }
        break;

      case 'sales':
        switch (section) {
          case 'daily':
            content = generateSalesDailyPDF(reportData, dateRange);
            break;
          case 'monthly':
            content = generateSalesMonthlyPDF(reportData, dateRange);
            break;
          case 'yearly':
            content = generateSalesYearlyPDF(reportData, dateRange);
            break;
          default:
            throw new Error('ไม่พบส่วนที่ระบุในรายงานยอดขาย');
        }
        break;

      case 'expenses':
        switch (section) {
          case 'summary':
            content = generateExpensesSummaryPDF(reportData, dateRange);
            break;
          case 'time':
            content = generateExpensesTimePDF(reportData, dateRange);
            break;
          case 'category':
            content = generateExpensesCategoryPDF(reportData, dateRange);
            break;
          case 'supplier':
            content = generateExpensesSupplierPDF(reportData, dateRange);
            break;
          default:
            throw new Error('ไม่พบส่วนที่ระบุในรายงานค่าใช้จ่าย');
        }
        break;

      case 'financial':
        switch (section) {
          case 'summary':
            content = generateFinancialSummaryPDF(reportData, dateRange);
            break;
          case 'cashflow':
            content = generateFinancialCashflowPDF(reportData, dateRange);
            break;
          default:
            throw new Error('ไม่พบส่วนที่ระบุในรายงานงบการเงิน');
        }
        break;

      case 'profit-loss':
        switch (section) {
          case 'daily':
            content = generateProfitLossDailyPDF(reportData, dateRange);
            break;
          case 'weekly':
            content = generateProfitLossWeeklyPDF(reportData, dateRange);
            break;
          case 'monthly':
            content = generateProfitLossMonthlyPDF(reportData, dateRange);
            break;
          case 'yearly':
            content = generateProfitLossYearlyPDF(reportData, dateRange);
            break;
          default:
            throw new Error('ไม่พบส่วนที่ระบุในรายงานกำไร/ขาดทุน');
        }
        break;

      default:
        throw new Error('ไม่พบประเภทรายงานที่ระบุ');
    }

    const docDefinition = {
      content: content,
      styles: getStyles(),
      defaultStyle: {
        font: 'THSarabunNew',
        fontSize: 18
      },
      pageSize: 'A4',
      pageMargins: [40, 60, 40, 60],
      footer: function(currentPage, pageCount) {
        return { 
          text: `หน้า ${currentPage} จาก ${pageCount}`, 
          alignment: 'center',
          style: 'footer'
        };
      }
    };

    return docDefinition;

  } catch (error) {
    console.error('Error generating section PDF:', error);
    throw error;
  }
};

// ฟังก์ชันสำหรับดาวน์โหลด PDF แยกตาม section
export const generateSectionReportPDF = async (reportType, section, reportData, reportTitle, dateRange = null) => {
  try {
    const docDefinition = await generateSectionPDF(reportType, section, reportData, reportTitle, dateRange);
    
    const sectionNames = {
      // Dashboard
      'overview': 'ภาพรวม',
      'activities': 'กิจกรรมล่าสุด',
      'events': 'กำหนดการที่จะมาถึง',
      // Inventory
      'summary': 'สรุปภาพรวม',
      'products': 'รายละเอียดสินค้า',
      // Sales
      'daily': 'รายวัน',
      'monthly': 'รายเดือน',
      'yearly': 'รายปี',
      // Expenses
      'time': 'ตามช่วงเวลา',
      'category': 'ตามหมวดหมู่',
      'supplier': 'ตามผู้จำหน่าย',
      // Financial
      'cashflow': 'กระแสเงินสด',
      // Profit-Loss
      'weekly': 'รายสัปดาห์'
    };

    const sectionTitle = sectionNames[section] || section;
    const fileName = `${reportTitle}_${sectionTitle}_${dayjs().format('YYYYMMDD_HHmm')}.pdf`;
    
    pdfMake.createPdf(docDefinition).download(fileName);
  } catch (error) {
    console.error('Error downloading section PDF:', error);
    throw error;
  }
};

// ฟังก์ชันสำหรับพรีวิว PDF แยกตาม section
export const previewSectionReportPDF = async (reportType, section, reportData, reportTitle, dateRange = null) => {
  try {
    const docDefinition = await generateSectionPDF(reportType, section, reportData, reportTitle, dateRange);
    pdfMake.createPdf(docDefinition).open();
  } catch (error) {
    console.error('Error previewing section PDF:', error);
    throw error;
  }
};

// Export เดิมเพื่อรองรับการใช้งานก่อนหน้า
export const generateReportPDF = generateSectionReportPDF;
export const previewReportPDF = previewSectionReportPDF;